import { FEEDBACK_KINDS, FEEDBACK_STATUSES } from '@steado/admin-contract/feedback';
import { z } from 'zod';

/**
 * The status and kind filters, and the page, live in the URL — same reasoning
 * as `food-requests-search.ts`: a link to "the open queue" is something an
 * operator can paste into Slack.
 *
 * No default status: the screen opens on everything, not just the open
 * queue, so a report resolved last week stays visible as context.
 */
export const feedbackSearchSchema = z.object({
  status: z.enum(FEEDBACK_STATUSES).optional().catch(undefined),
  kind: z.enum(FEEDBACK_KINDS).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

export type FeedbackSearch = z.infer<typeof feedbackSearchSchema>;
